import { Paper, Typography } from '@mui/material';
import PropTypes from 'prop-types';
import { Box } from '@mui/system';
import moment from 'moment';
import React from 'react';
import currencyHelper from '../../../helpers/currencyHelper';

const AccountInfoCard = ({ account }) => {
  const currency = account?.ccy ? currencyHelper(account.ccy) : currencyHelper('ZAR');

  const balance = Number(account?.model?.closing || 0);

  return (
    <Paper
      sx={{
        backgroundColor: '#FBF0EA',
        boxShadow: 'none',
        p: 2.5,
        width: '100%',
      }}>
      <Box display="flex" justifyContent="space-between" alignItems="flex-start" width="100%">
        {/* LEFT SIDE */}
        <Box flex={1}>
          <Typography
            sx={{
              color: '#C56A2D',
              fontWeight: 700,
              fontSize: '12px',
              textTransform: 'uppercase',
              letterSpacing: 0.5
            }}>
            {account.product}
            {account.accountNumber ? ` - ${account.accountNumber}` : ''}
          </Typography>

          {account.administrator && (
            <Typography
              sx={{
                fontSize: '11px',
                lineHeight: 1.2
              }}>
              Administered by {account.administrator}
            </Typography>
          )}

          <Typography
            sx={{
              fontSize: '11px',
              lineHeight: 1.2
            }}>
            {account.model?.name}
          </Typography>

          {account.fundName && (
            <Typography
              sx={{
                mt: 3,
                fontSize: '12px'
              }}>
              {account.fundName}
            </Typography>
          )}
        </Box>

        {/* RIGHT SIDE */}
        <Box textAlign="right">
          <Typography
            sx={{
              fontSize: '11px'
            }}>
            Date
          </Typography>

          <Typography
            sx={{
              color: '#C56A2D',
              fontWeight: 700,
              fontSize: '28px',
              lineHeight: 1.1
            }}>
            {currency}{' '}
            {balance.toLocaleString('en-ZA', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            })}
          </Typography>

          <Typography
            sx={{
              mt: 2,
              fontSize: '11px'
            }}>
            {moment(account.closingDate).format('DD MMM YYYY')}
          </Typography>

          <Typography
            sx={{
              fontWeight: 600,
              fontSize: '14px'
            }}>
            {currency}{' '}
            {balance.toLocaleString('en-ZA', {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            })}
          </Typography>
        </Box>
      </Box>
    </Paper>
  );
};

export default AccountInfoCard;

AccountInfoCard.propTypes = {
  account: PropTypes.object.isRequired
};
